exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled {\r\n    opacity: 0.1;\r\n    cursor: not-allowed;     \r\n    pointer-events: none;  \r\n}\r\n.hyperlink-content {\r\n    cursor: pointer;\r\n    color: #0073AB;\r\n}\r\na:hover {\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component.css
// module id = ../../../../../src/app/shared/lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component.css
// module chunks = main